import { ModuleRepeaterComponent } from "@/types/modules";
import styles from "@/styles/modules/components/our-story/moduleRepeater.module.scss";
import ModuleRepeaterItem from "./ModuleRepeaterItem";

interface ModuleRepeaterProps {
  modules: ModuleRepeaterComponent[];
}

export default function ModuleRepeater({ modules }: ModuleRepeaterProps) {
  return (
    <section className={styles.moduleRepeater}>
      <div className={styles.moduleRepeaterContainer}>
        {module &&
          modules.map((module, i) => (
            <ModuleRepeaterItem key={i} module={module} />
          ))}
      </div>
    </section>
  );
}
